import { ImageX } from '@bridebook/ui';
import {
  GLAMOUR_ACCENTS,
  Palette,
  PALETTE_ACCENTS,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/palette-config';
import { useThemeContext } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/theme-provider';
import { toMainPalette } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/utils';

export const TopDesktopAccent = () => {
  const { palette } = useThemeContext();
  const mainPalette = toMainPalette(palette);

  switch (mainPalette) {
    case Palette.Glamour:
      return (
        <div className="pointer-events-none relative hidden h-[120px] w-full @screen-lg:block">
          <div className="absolute top-[-40px] left-[-170px] h-[500px] w-[500px]">
            <ImageX w={500} h={500} src={GLAMOUR_ACCENTS.desktop} fit="cover" />
          </div>
          <div className="absolute top-[-40px] right-[-170px] h-[500px] w-[500px] scale-x-[-1]">
            <ImageX w={500} h={500} src={GLAMOUR_ACCENTS.desktop} fit="cover" />
          </div>
        </div>
      );
    case Palette.Timeless:
      return (
        <div className="pointer-events-none relative hidden h-[120px] w-full @screen-lg:block">
          <div className="absolute top-[-8px] left-1/2 h-[88px] w-[546px] -translate-x-1/2">
            <ImageX w={546} h={88} src={PALETTE_ACCENTS[Palette.Timeless]} fit="cover" />
          </div>
        </div>
      );
    case Palette.Blossom:
      return (
        <div className="pointer-events-none relative hidden h-[120px] w-full @screen-lg:block">
          <div className="absolute top-[-19px] left-1/2 h-[112px] w-[83px] -translate-x-1/2">
            <ImageX w={83} h={112} src={PALETTE_ACCENTS[Palette.Blossom]} fit="cover" />
          </div>
        </div>
      );
    case Palette.Amore:
      return (
        <div className="pointer-events-none relative hidden h-[120px] w-full @screen-lg:block">
          <div className="absolute top-[-14px] left-[-112px] h-[340px] w-[340px]">
            <ImageX w={340} h={340} src={PALETTE_ACCENTS[Palette.Amore]} fit="cover" />
          </div>
          <div className="absolute top-[-14px] right-[-112px] h-[340px] w-[340px] scale-x-[-1]">
            <ImageX w={340} h={340} src={PALETTE_ACCENTS[Palette.Amore]} fit="cover" />
          </div>
        </div>
      );
    default:
      return null;
  }
};
